module.exports = "/static/media/loading.468e9e96.svg";


//////////////////
// WEBPACK FOOTER
// ../public/images/loading.svg
// module id = 1669
// module chunks = 0